//
//
//
//
//
//

import TabBar from '@/components/common_tabbar.vue'
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { TabBar },
  data() {
    return {
      tabbar_list: [
        {
          icon: require("../../../assets/images/tabbar/2_13.png"),
          icon_select: require("../../../assets/images/tabbar/1_35.png"),
          text: "工作台",
          link: "/Mms/WorkBench",
        },
        {
          icon: require("../../../assets/images/tabbar/1_37.png"),
          icon_select:require("../../../assets/images/tabbar/2_15.png"),
          text: "积分",
          link: "/Mms/WorkBench/TabPoints",
        },
        {
          icon: require("../../../assets/images/tabbar/1_39.png"),
          icon_select: require("../../../assets/images/tabbar/1_40.png"),
          text: "活动",
          link: "/Mms/WorkBench/TabActivity",
        },
        {
          icon: require("../../../assets/images/tabbar/1_42.png"),
          icon_select: require("../../../assets/images/tabbar/3_19.png"),
          text: "我的",
          link: "/Mms/WorkBench/TabMy",
        }
      ]
    };
  },
  mounted() {
    this.$appBox.setWorkbenchUrl(this);
  },
  destroyed () {
    localStorage.removeItem('bdOpenId')
    localStorage.removeItem('fansOpenId')
  },
  methods: {
    go_page(url) {
      this.$router.push(url);
    }
  }
};
